import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'modal-dialog',
    styleUrls: ['./modal.component.scss'],
    template: `
    <h2 mat-dialog-title>{{data?.title}}</h2>
    <mat-dialog-content class="mat-typography">
    <p style="white-space: pre-line">{{data.message}}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
    <button class="color" mat-button *ngIf="data.showCancel" mat-dialog-close>{{data.cancelButtonText}}</button>
    <span class="spacer"></span>
    <button class="color" mat-button [mat-dialog-close]="true" cdkFocusInitial>{{data.saveButtonText}}</button>
    </mat-dialog-actions>
    `
})
export class ModalDialog {
    constructor(@Inject(MAT_DIALOG_DATA) public data, private dialogRef: MatDialogRef<ModalDialog>) {
        dialogRef.disableClose = true;
     }
}